function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2475 1650",
    style: {
      enableBackground: "new 0 0 2475 1650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -2092.0503,
    y1: 743.8094,
    x2: -4029.8335,
    y2: 751.1215,
    gradientTransform: "matrix(-0.9998 -0.0186 -0.0186 0.9998 -1522.2557 23.3991)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M363.702,905.627l42.704-48.767c0,0,191.74-169.574,198.568-360.922 c6.828-191.347,91.732-217.068,294.909-229.086c171.775-10.161,370.335-38.969,529.935,69.622 c70.041,47.655,152.937,71.877,236.986,68.979l185.251-6.387c88.386-3.047,175.365,23.817,247.235,76.583 c106.545,78.224,221.281,222.219,174.473,467.121c-7.948,41.585-12.974,85.177-13.763,127.538l-1.938,104.056 c-1.702,91.384-73.036,165.156-162.155,167.107l-1390.44,30.445c-142.942,3.129-280.357-55.795-378.558-162.249 c-26.186-28.387-40.395-66.19-39.668-105.276C288.611,1030.9,315.788,960.345,363.702,905.627z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2131.881,319.475c12.863,103.465,77.201,741.459-262.118,945.039 c-10.273,6.163-23.454-0.699-24.32-12.647c-5.506-76.042-8.944-317.688,130.619-602.884 c100.695-205.769,137.604-298.53,149.239-330.263C2126.534,315.361,2131.44,315.924,2131.881,319.475z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1845.443,1253.867c-0.322,0-0.65-0.079-0.954-0.244c-0.97-0.528-1.328-1.742-0.801-2.712 c89.604-164.732,150.934-345.185,186.605-467.559c40.407-138.621,57.586-234.664,56.995-240.324 c-0.253-1.018,0.329-2.07,1.344-2.388c1.058-0.327,2.177,0.257,2.506,1.311c1.74,5.559-18.564,110.219-56.276,240.017 c-35.807,123.242-97.431,304.972-187.66,470.854C1846.839,1253.489,1846.151,1253.867,1845.443,1253.867z M2087.297,543.065 c0.008,0.031,0.017,0.058,0.024,0.081C2087.313,543.119,2087.305,543.092,2087.297,543.065z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1901.719,1298.668c79.951,15.363,316.063,24.993,403.096-366.85 c2.471-11.126-11.376-18.337-19.021-9.885c-35.81,39.593-99.508,106.903-153.628,127.616 c-167.674,64.172-228.374,167.403-248.402,215.754C1877.832,1279.623,1886.498,1295.744,1901.719,1298.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1893.986,1286.203c-0.867,0-1.665-0.568-1.92-1.442c-0.308-1.061,0.302-2.17,1.362-2.479 c117.108-34.056,203.075-99.539,254.571-148.476c55.833-53.058,84.316-98.65,84.597-99.104c0.582-0.939,1.813-1.229,2.754-0.648 c0.938,0.581,1.229,1.813,0.648,2.753c-0.283,0.458-28.975,46.406-85.146,99.806c-32.98,31.354-68.858,59.129-106.639,82.553 c-47.234,29.285-97.59,51.813-149.669,66.958C1894.359,1286.177,1894.171,1286.203,1893.986,1286.203z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M783.51,987.403c0,0,6.497-170.385-71.354-217.129c-77.851-46.743-226.706-77.403-228.793-322.224 c-1.222-143.329-3.869-206.025-5.854-233.375c-0.774-10.669,8.818-19.134,19.3-17.003 c74.15,15.072,314.855,76.185,363.131,241.767C917.172,635.737,783.51,987.403,783.51,987.403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M552.046,267.947c0,0,0.518,0.494,1.521,1.45c0.994,0.975,2.468,2.422,4.391,4.309 c3.798,3.805,9.348,9.409,16.159,16.773c3.384,3.7,7.205,7.734,11.18,12.288c4.009,4.524,8.387,9.383,12.876,14.735 c2.266,2.658,4.605,5.402,7.012,8.227c2.409,2.824,4.779,5.817,7.271,8.841c2.468,3.044,5,6.166,7.592,9.362 c2.554,3.225,5.106,6.574,7.746,9.968c2.632,3.4,5.32,6.871,8.058,10.409c2.654,3.601,5.358,7.269,8.109,11.001 c2.745,3.736,5.537,7.536,8.372,11.394c2.741,3.925,5.524,7.91,8.346,11.95c2.808,4.049,5.713,8.116,8.547,12.304 c2.783,4.223,5.6,8.497,8.447,12.819c2.814,4.343,5.735,8.685,8.542,13.159c2.762,4.503,5.55,9.048,8.362,13.632 c2.792,4.595,5.689,9.181,8.459,13.888c2.712,4.741,5.444,9.517,8.192,14.322c2.736,4.812,5.542,9.624,8.264,14.514 c2.619,4.947,5.252,9.919,7.895,14.91c2.643,4.992,5.297,10.004,7.958,15.031c2.489,5.115,4.986,10.245,7.488,15.384 c2.498,5.142,5.001,10.295,7.506,15.452l0.94,1.934l0.117,0.242l0.138,0.3l0.215,0.491l0.43,0.982l1.72,3.928l3.441,7.859 c9.023,21.232,16.613,43.018,22.819,64.798c6.213,21.786,11.05,43.573,14.71,64.819c3.69,21.245,6.034,41.971,7.578,61.657 c1.522,19.692,2.151,38.361,2.186,55.588c0.059,17.229-0.578,33.015-1.464,46.98c-0.892,13.966-2.067,26.113-3.232,36.095 c-1.156,9.984-2.361,17.794-3.23,23.116c-0.442,2.66-0.805,4.699-1.057,6.074c-0.266,1.386-0.403,2.101-0.403,2.101 c-0.224,1.17-1.354,1.936-2.523,1.712c-1.154-0.221-1.916-1.325-1.72-2.478l0.01-0.055c0,0,0.118-0.692,0.347-2.032 c0.221-1.354,0.538-3.37,0.922-6.009c0.77-5.276,1.754-13.047,2.778-22.965c1.014-9.919,2.008-21.993,2.694-35.867 c0.692-13.874,1.04-29.547,0.894-46.638c-0.168-17.09-0.936-35.6-2.596-55.104c-1.637-19.506-4.264-39.991-7.878-61.02 c-3.64-21.023-8.444-42.568-14.602-64.094c-6.154-21.53-13.669-43.027-22.56-63.904l-3.448-7.856l-1.723-3.927l-0.431-0.982 l-0.215-0.491l-0.201-0.427l-0.921-1.927c-2.457-5.138-4.911-10.271-7.36-15.394c-2.453-5.122-4.901-10.233-7.342-15.33 c-2.613-5.011-5.219-10.007-7.815-14.984c-2.595-4.977-5.18-9.934-7.753-14.867c-2.676-4.877-5.435-9.677-8.124-14.477 c-2.702-4.793-5.388-9.558-8.055-14.288c-2.725-4.697-5.577-9.274-8.325-13.861c-2.767-4.576-5.511-9.114-8.23-13.608 c-2.763-4.467-5.643-8.802-8.413-13.14c-2.773-4.337-5.516-8.627-8.227-12.866c-2.762-4.204-5.596-8.288-8.334-12.355 c-2.752-4.059-5.467-8.062-8.141-12.005c-2.768-3.878-5.494-7.696-8.175-11.452c-2.687-3.752-5.328-7.44-7.921-11.061 c-2.677-3.558-5.305-7.049-7.878-10.469c-2.582-3.414-5.076-6.784-7.575-10.03c-2.536-3.218-5.013-6.361-7.428-9.425 c-2.418-3.062-4.717-6.093-7.056-8.954c-2.339-2.862-4.61-5.642-6.811-8.336c-4.36-5.424-8.616-10.351-12.515-14.94 c-3.866-4.619-7.584-8.711-10.878-12.467c-6.646-7.458-11.985-13.211-15.667-17.09c-1.853-1.92-3.274-3.392-4.231-4.384 c-0.976-0.982-1.479-1.489-1.479-1.489l-0.007-0.007c-0.476-0.479-0.474-1.254,0.006-1.73 C550.81,267.497,551.568,267.492,552.046,267.947z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M638.438,1371.599c10.664,8.218-81.603-172.914-70.628-425.684 c5.172-119.111,34.343-263.731-20.053-332.816c-45.272-57.497-237.382-66.093-300.555-67.358 c-7.894-0.158-12.412,8.935-7.5,15.116c24.219,30.473,74.933,101.047,79.351,162.674c5.823,81.229,68.953,144.984,131.683,171.523 c62.73,26.539,96.51,46.783,107.098,157.889C568.421,1164.05,608.138,1348.249,638.438,1371.599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M326.02,596.649c0,0,1.837,0.426,5.21,1.375c3.375,0.957,8.31,2.417,14.491,4.572 c6.182,2.151,13.626,4.952,21.996,8.578c8.365,3.63,17.686,8.03,27.514,13.481c9.832,5.434,20.213,11.844,30.668,19.39 c10.442,7.552,20.991,16.215,30.963,26.175c9.968,9.952,19.4,21.147,27.665,33.447c8.274,12.289,15.353,25.683,20.841,39.713 l1.992,5.287l0.995,2.643c0.299,0.892,0.561,1.796,0.843,2.694c1.096,3.598,2.245,7.184,3.249,10.793 c1.907,7.18,3.807,14.331,5.692,21.426c1.823,7.12,3.633,14.183,5.42,21.161c1.771,6.982,3.431,13.899,5.112,20.691 c1.674,6.794,3.209,13.502,4.771,20.053c1.554,6.553,2.919,13.001,4.332,19.257c2.751,12.53,5.235,24.402,7.457,35.375 c1.083,5.492,2.121,10.755,3.108,15.761c0.924,5.018,1.8,9.778,2.623,14.252c1.591,8.957,2.931,16.774,3.969,23.223 c1.055,6.446,1.793,11.526,2.284,14.993c0.475,3.473,0.728,5.325,0.728,5.325c0.063,0.46-0.259,0.884-0.719,0.947 c-0.452,0.062-0.869-0.248-0.943-0.695l-0.003-0.02c0,0-0.303-1.835-0.87-5.276c-0.578-3.443-1.482-8.485-2.649-14.899 c-1.167-6.414-2.664-14.189-4.435-23.097c-1.807-8.901-3.87-18.937-6.195-29.87c-2.352-10.927-4.978-22.749-7.877-35.224 c-2.924-12.469-6.042-25.61-9.369-39.18c-1.703-6.775-3.385-13.677-5.177-20.637c-1.808-6.956-3.638-13.997-5.483-21.094 c-1.91-7.088-3.835-14.233-5.768-21.406c-0.997-3.544-2.151-7.04-3.196-10.577c-0.272-0.88-0.524-1.768-0.813-2.643l-0.965-2.593 l-1.929-5.189c-5.315-13.771-12.194-26.93-20.261-39.029c-8.059-12.109-17.28-23.157-27.051-33 c-9.769-9.852-20.021-18.579-30.268-26.152c-10.242-7.584-20.443-14.055-30.123-19.559c-9.691-5.488-18.822-10.089-27.067-13.839 c-8.241-3.762-15.585-6.688-21.686-8.944c-6.104-2.25-10.957-3.862-14.286-4.887c-3.332-1.031-5.118-1.493-5.118-1.493 c-0.361-0.093-0.578-0.462-0.485-0.823c0.092-0.355,0.45-0.571,0.806-0.489L326.02,596.649z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M624.742,1403.864c7.173,3.782-40.405-78.11-44.056-150.259 c-3.651-72.149-19.927-195.289-82.145-268.952c-62.217-73.662-130.352-80.383-216.204-13.417 c-71.544,55.805-116.171,83.967-142.343,89.202c-6.48,1.296-9.788,8.612-6.634,14.42c16.786,30.913,64.246,101.921,143.932,96.922 c101.645-6.376,224.832-72.453,262.377-17.331c37.546,55.122,32.725,85.965,33.878,112.088 C574.7,1292.661,577.271,1378.836,624.742,1403.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M311.972,1060.575c0,0,1.064-0.987,3.104-2.74c2.042-1.759,5.075-4.291,9.065-7.35 c3.985-3.064,8.911-6.676,14.737-10.575c5.822-3.903,12.597-8.009,20.216-12.094c7.62-4.077,16.123-8.092,25.49-11.457 c1.174-0.41,2.357-0.822,3.547-1.237c1.205-0.373,2.418-0.748,3.639-1.126c0.61-0.189,1.223-0.378,1.837-0.568 c0.621-0.166,1.245-0.332,1.87-0.499c1.252-0.331,2.51-0.664,3.776-0.999c5.107-1.159,10.366-2.264,15.815-2.772 c2.708-0.377,5.477-0.411,8.25-0.591c1.391-0.023,2.789,0.011,4.191,0.015l2.107,0.017l2.112,0.154 c5.659,0.244,11.307,1.364,16.93,2.794c5.382,1.481,10.957,3.35,16.323,5.389c5.375,2.119,10.66,4.53,15.807,7.218 c5.115,2.754,10.066,5.805,14.812,9.118c4.704,3.375,9.179,7.017,13.404,10.869c8.34,7.814,15.688,16.414,21.681,25.461 c6.059,9.003,11.044,18.241,15.177,27.24c4.136,9.004,7.431,17.77,10.167,25.945c0.342,1.022,0.681,2.033,1.017,3.034 c0.308,1.009,0.612,2.006,0.914,2.993c0.593,1.975,1.204,3.895,1.741,5.783c1.036,3.787,2.088,7.359,2.907,10.76 c0.428,1.695,0.843,3.336,1.243,4.92c0.369,1.591,0.724,3.125,1.065,4.598c0.685,2.946,1.3,5.655,1.789,8.116 c0.507,2.457,0.963,4.649,1.328,6.563c0.351,1.916,0.649,3.546,0.892,4.867c0.484,2.642,0.742,4.051,0.742,4.051 c0.075,0.407-0.195,0.798-0.602,0.873c-0.399,0.073-0.783-0.185-0.868-0.578l-0.003-0.015c0,0-0.3-1.396-0.864-4.015 c-0.282-1.309-0.629-2.923-1.038-4.821c-0.44-1.89-0.946-4.063-1.513-6.496c-0.543-2.438-1.216-5.12-1.966-8.035 c-0.373-1.458-0.762-2.974-1.164-4.548c-0.434-1.565-0.884-3.186-1.348-4.861c-0.891-3.36-2.018-6.883-3.132-10.616 c-0.575-1.861-1.226-3.75-1.858-5.695c-0.321-0.971-0.645-1.952-0.973-2.945c-0.351-0.984-0.706-1.979-1.065-2.985 c-2.824-8.057-6.205-16.677-10.405-25.49c-4.198-8.809-9.225-17.811-15.272-26.526c-6.021-8.729-13.129-17.116-21.285-24.645 c-4.119-3.718-8.476-7.228-13.05-10.479c-4.617-3.189-9.432-6.124-14.407-8.774c-5.009-2.584-10.155-4.903-15.395-6.941 c-5.301-1.977-10.503-3.706-15.99-5.191c-5.275-1.349-10.635-2.48-16.022-2.737l-2.01-0.162l-2.013-0.028 c-1.34-0.012-2.676-0.055-4.007-0.042c-2.662,0.159-5.313,0.168-7.926,0.517c-5.244,0.45-10.342,1.489-15.303,2.578 c-1.232,0.318-2.457,0.633-3.675,0.947c-0.609,0.158-1.216,0.315-1.822,0.473c-0.599,0.181-1.197,0.362-1.793,0.542 c-1.192,0.36-2.376,0.718-3.553,1.073c-1.165,0.398-2.322,0.793-3.471,1.185c-9.208,3.114-17.651,6.875-25.239,10.742 c-7.602,3.851-14.339,7.838-20.236,11.49c-5.893,3.663-10.895,7.079-14.947,9.984c-4.046,2.914-7.163,5.29-9.268,6.934 c-2.106,1.651-3.182,2.563-3.182,2.563c-0.328,0.278-0.82,0.238-1.098-0.091c-0.27-0.319-0.24-0.792,0.063-1.074L311.972,1060.575 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092423725133862664900000006686668817209904534_",
    gradientUnits: "userSpaceOnUse",
    x1: 1141.1346,
    y1: 1293.3849,
    x2: 1467.7524,
    y2: 313.5287
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092423725133862664900000006686668817209904534_)"
    },
    d: "M1984.489,1328.931 c0,14.052-11.508,25.549-25.574,25.549H575.986c-14.066,0-25.574-11.497-25.574-25.549L538.905,534.2 c0-14.052,16.556-41.485,46.897-39.423l1351.551-34.972c17.648-0.456,34.712,6.336,47.209,18.793 c12.498,12.457,19.336,29.489,18.919,47.121L1984.489,1328.931z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145770576802031279320000009243489051203873175_",
    gradientUnits: "userSpaceOnUse",
    x1: 1218.5634,
    y1: 1343.4916,
    x2: 1366.2319,
    y2: 117.0142
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145770576802031279320000009243489051203873175_)"
    },
    d: "M1959.24,1304.42 c0,13.307-10.888,24.194-24.195,24.194H609.336c-13.307,0-24.195-10.888-24.195-24.194l-10.859-721.464 c1.279-43.416,39.343-59.02,62.416-58.099l1295.376-34.753c12.399-0.333,24.39,4.441,33.168,13.204 c8.778,8.763,13.573,20.746,13.261,33.145L1959.24,1304.42z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.24
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M599.469,959.127c-0.546,0-0.992-0.438-1-0.985l-0.859-58.51 c-0.008-0.552,0.433-1.006,0.985-1.015c0.567-0.029,1.007,0.433,1.015,0.985l0.859,58.51c0.008,0.552-0.433,1.006-0.985,1.015 C599.479,959.127,599.474,959.127,599.469,959.127z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.24
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M597.364,815.748c-0.546,0-0.992-0.438-1-0.985l-3.291-224.091 c0.066-14.68,4.579-26.404,13.41-34.867c16.132-15.457,41.435-14.678,42.506-14.637l413.722-11.101 c0.528-0.033,1.012,0.421,1.026,0.973c0.015,0.552-0.421,1.012-0.974,1.026l-413.772,11.101 c-1.109-0.039-25.598-0.797-41.125,14.082c-8.425,8.073-12.729,19.315-12.794,33.412l3.291,224.072 c0.008,0.552-0.434,1.006-0.985,1.015C597.373,815.748,597.368,815.748,597.364,815.748z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.24
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M643.547,1264.396c1.388-59.63,0.871-587.667-2.55-633.271 c-3.421-45.604,67.603-54.157,176.648-59.289c109.044-5.132,1029.095-25.451,1052.785-27.372 c53.248-4.318,64.27,75.272,58.943,248.056c-4.002,129.81-10.636,343.651-13.688,441.991 c-0.909,29.281-24.842,52.514-54.137,52.594c-221.402,0.609-1069.971,3.041-1126.461,4.723 C670.079,1293.765,642.997,1288.041,643.547,1264.396z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178914699242983425470000010167665254375805621_",
    gradientUnits: "userSpaceOnUse",
    x1: 1371.6227,
    y1: 725.7684,
    x2: 1283.6235,
    y2: 1369.7661
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178914699242983425470000010167665254375805621_)"
    },
    d: "M2061.764,1420.453H501.173 c-19.203,0-34.914-15.711-34.914-34.914l0,0c0-19.203,15.711-34.914,34.914-34.914h1560.591c19.203,0,34.914,15.711,34.914,34.914 l0,0C2096.677,1404.742,2080.966,1420.453,2061.764,1420.453z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1799.211,1212H754.926c-14.345,0-25.581-12.163-25.581-27.691V648.008 c0-15.102,11.263-27.142,25.642-27.41l0.019,1l-0.019-1l1044.13-19.422c7.092-0.141,13.876,2.659,19.023,7.861 c5.215,5.27,8.205,12.396,8.205,19.549v555.723C1826.345,1199.319,1813.919,1212,1799.211,1212z M1799.6,603.172 c-0.149,0-0.297,0.001-0.446,0.004l-1044.13,19.422c-13.277,0.247-23.679,11.408-23.679,25.41v536.301 c0,14.406,10.358,25.691,23.581,25.691h1044.285c13.624,0,25.134-11.765,25.134-25.691V628.586c0-6.631-2.78-13.244-7.627-18.143 C1812.068,605.744,1806.004,603.172,1799.6,603.172z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040559472564798698640000009438560300409158807_",
    gradientUnits: "userSpaceOnUse",
    x1: 1136.2422,
    y1: 701.1975,
    x2: 1312.243,
    y2: -258.8034
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000040559472564798698640000009438560300409158807_)"
    },
    d: "M1426.345,715.083 c0-11.091-8.991-20.083-20.083-20.083H794.428c-11.092,0-20.083,8.991-20.083,20.083v363.834c0,11.091,8.992,20.083,20.083,20.083 h611.834c11.092,0,20.083-8.991,20.083-20.083V715.083z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1715.609,828h-221.471c-15.621,0-23.794-12.46-23.794-24.769v-84.274 c0-12.402,8.173-24.958,23.794-24.958h221.471c15.039,0,28.735,11.896,28.735,24.958v84.274 C1744.345,816.194,1730.649,828,1715.609,828z M1494.139,696c-14.308,0-21.794,11.549-21.794,22.958v84.274 c0,11.315,7.486,22.769,21.794,22.769h221.471c13.992,0,26.735-10.852,26.735-22.769v-84.274c0-12.015-12.743-22.958-26.735-22.958 H1494.139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1715.609,997h-221.471c-14.01,0-23.794-9.83-23.794-23.903v-84.274 c0-12.518,8.339-25.823,23.794-25.823h221.471c14.771,0,28.735,12.549,28.735,25.823v84.274 C1744.345,985.83,1730.917,997,1715.609,997z M1494.139,865c-14.155,0-21.794,12.274-21.794,23.823v84.274 c0,12.897,8.962,21.903,21.794,21.903h221.471c14.242,0,26.735-10.235,26.735-21.903v-84.274c0-12.245-12.993-23.823-26.735-23.823 H1494.139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1715.609,1166h-221.471c-14.231,0-23.794-9.258-23.794-23.038v-84.274 c0-12.453,8.339-25.688,23.794-25.688h221.471c14.771,0,28.735,12.484,28.735,25.688v84.274 C1744.345,1156.743,1729.486,1166,1715.609,1166z M1494.139,1035c-14.155,0-21.794,12.205-21.794,23.688v84.274 c0,12.583,8.759,21.038,21.794,21.038h221.471c12.911,0,26.735-8.454,26.735-21.038v-84.274c0-12.176-12.993-23.688-26.735-23.688 H1494.139z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M1193.688,1125.991c-62.333-0.153-344.573-0.804-407.034-0.219 c-6.721,0.063-12.31,5.522-12.31,12.243v6.837c0,6.654,4.771,12.092,11.424,12.245l406.441,9.337 c3.296,0.076,7.787-1.181,10.145-3.485c2.358-2.305,4.99-5.463,4.99-8.759v-15.954 C1207.345,1131.484,1200.44,1126.007,1193.688,1125.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1825.345,659h-1095c-0.553,0-1-0.448-1-1s0.447-1,1-1h1095c0.553,0,1,0.448,1,1 S1825.898,659,1825.345,659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1693.895,643h-2.1c-6.313,0-11.45-5.137-11.45-11.45v-2.1c0-6.313,5.137-11.45,11.45-11.45h2.1 c6.314,0,11.45,5.137,11.45,11.45v2.1C1705.345,637.863,1700.208,643,1693.895,643z M1691.795,620c-5.211,0-9.45,4.239-9.45,9.45 v2.1c0,5.211,4.239,9.45,9.45,9.45h2.1c5.211,0,9.45-4.239,9.45-9.45v-2.1c0-5.211-4.239-9.45-9.45-9.45H1691.795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1740.895,643h-2.1c-6.313,0-11.45-5.137-11.45-11.45v-2.1c0-6.313,5.137-11.45,11.45-11.45h2.1 c6.314,0,11.45,5.137,11.45,11.45v2.1C1752.345,637.863,1747.208,643,1740.895,643z M1738.795,620c-5.211,0-9.45,4.239-9.45,9.45 v2.1c0,5.211,4.239,9.45,9.45,9.45h2.1c5.211,0,9.45-4.239,9.45-9.45v-2.1c0-5.211-4.239-9.45-9.45-9.45H1738.795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1790.895,643h-2.1c-6.313,0-11.45-5.137-11.45-11.45v-2.1c0-6.313,5.137-11.45,11.45-11.45h2.1 c6.314,0,11.45,5.137,11.45,11.45v2.1C1802.345,637.863,1797.208,643,1790.895,643z M1788.795,620c-5.211,0-9.45,4.239-9.45,9.45 v2.1c0,5.211,4.239,9.45,9.45,9.45h2.1c5.211,0,9.45-4.239,9.45-9.45v-2.1c0-5.211-4.239-9.45-9.45-9.45H1788.795z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M817.345,812c-0.553,0-1-0.448-1-1v-79c0-0.552,0.447-1,1-1h60c0.553,0,1,0.448,1,1s-0.447,1-1,1 h-59v78C818.345,811.552,817.898,812,817.345,812z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1382.345,812c-0.553,0-1-0.448-1-1v-78h-59c-0.553,0-1-0.448-1-1s0.447-1,1-1h60 c0.553,0,1,0.448,1,1v79C1383.345,811.552,1382.898,812,1382.345,812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M877.345,1051h-60c-0.553,0-1-0.448-1-1v-76c0-0.552,0.447-1,1-1c0.553,0,1,0.448,1,1v75h59 c0.553,0,1,0.448,1,1S877.898,1051,877.345,1051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1382.345,1051h-60c-0.553,0-1-0.448-1-1s0.447-1,1-1h59v-75c0-0.552,0.447-1,1-1 c0.553,0,1,0.448,1,1v76C1383.345,1050.552,1382.898,1051,1382.345,1051z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1088.443,997h-0.197c-54.534,0-98.901-44.367-98.901-98.902v-0.196 c0-54.535,44.367-98.902,98.901-98.902h0.197c54.534,0,98.901,44.367,98.901,98.902v0.196 C1187.345,952.633,1142.978,997,1088.443,997z M1088.246,801c-53.432,0-96.901,43.47-96.901,96.902v0.196 c0,53.432,43.47,96.902,96.901,96.902h0.197c53.432,0,96.901-43.47,96.901-96.902v-0.196c0-53.432-43.47-96.902-96.901-96.902 H1088.246z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183240026913419820120000006497739228889590457_",
    gradientUnits: "userSpaceOnUse",
    x1: 1052.2395,
    y1: 897.7056,
    x2: 1157.0947,
    y2: 897.7056
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183240026913419820120000006497739228889590457_)"
    },
    d: "M1059.85,949.128 c-2.82,0-5.144-2.248-5.221-5.084l-2.387-89.111c-0.078-2.939,1.343-5.653,3.8-7.263c2.457-1.611,5.512-1.832,8.177-0.586 l88.026,41.172c2.905,1.357,4.762,4.193,4.847,7.4c0.084,3.206-1.621,6.136-4.452,7.646l-77.703,41.423 c-2.55,1.357-5.712,0.392-7.068-2.152c-1.359-2.546-0.394-5.711,2.152-7.068l74.109-39.509l-81.353-38.049l2.299,85.816 c0.077,2.885-2.199,5.286-5.083,5.364C1059.944,949.128,1059.897,949.128,1059.85,949.128z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1010.023,520.938c-1.087,0-2.108-0.59-2.643-1.567l-11.523-21.035 c-11.376-0.751-22.477-3.271-33.019-7.496l-19.474,13.975c-1.044,0.75-2.453,0.755-3.501,0.011l-24.017-17.01 c-1.049-0.744-1.512-2.073-1.151-3.307l6.722-23.008c-7.483-8.544-13.545-18.181-18.028-28.66l-23.667-3.891 c-1.27-0.209-2.268-1.201-2.483-2.469l-4.953-29.009c-0.217-1.269,0.396-2.536,1.523-3.153l21.035-11.523 c0.751-11.376,3.272-22.478,7.495-33.019l-13.975-19.474c-0.75-1.044-0.755-2.452-0.012-3.501l17.011-24.016 c0.744-1.051,2.073-1.512,3.308-1.151l23.007,6.72c8.542-7.483,18.179-13.543,28.66-18.028l3.892-23.667 c0.208-1.27,1.2-2.267,2.468-2.484l29.011-4.953c1.27-0.216,2.533,0.396,3.151,1.523l11.523,21.035 c11.376,0.751,22.478,3.271,33.02,7.496l19.474-13.975c1.044-0.75,2.452-0.754,3.502-0.01l24.016,17.01 c1.05,0.743,1.512,2.072,1.151,3.307l-6.721,23.007c7.483,8.543,13.544,18.179,18.027,28.661l23.667,3.891 c1.269,0.208,2.268,1.2,2.483,2.469l4.954,29.009c0.217,1.268-0.396,2.535-1.524,3.152l-21.035,11.524 c-0.752,11.376-3.273,22.479-7.496,33.019l13.976,19.474c0.749,1.046,0.753,2.453,0.011,3.502l-17.01,24.016 c-0.744,1.049-2.068,1.514-3.308,1.152l-23.008-6.721c-8.543,7.482-18.179,13.543-28.66,18.027l-3.891,23.668 c-0.208,1.269-1.2,2.266-2.468,2.483l-29.011,4.954C1010.362,520.924,1010.192,520.938,1010.023,520.938z M962.566,488.573 l0.512,0.208c10.662,4.335,21.917,6.89,33.451,7.594l0.552,0.034l12.053,22.001c0.209,0.38,0.642,0.585,1.062,0.513l29.011-4.954 c0.427-0.073,0.762-0.409,0.832-0.836l4.068-24.755l0.509-0.214c10.647-4.492,20.417-10.637,29.035-18.264l0.414-0.366 l24.065,7.03c0.415,0.121,0.864-0.035,1.115-0.389l17.009-24.015c0.251-0.354,0.249-0.828-0.003-1.18l-14.617-20.368l0.207-0.511 c4.335-10.661,6.891-21.916,7.595-33.452l0.033-0.551l22.002-12.053c0.38-0.208,0.586-0.635,0.514-1.062l-4.954-29.009 c-0.073-0.427-0.409-0.761-0.837-0.832l-24.755-4.069l-0.214-0.509c-4.492-10.648-10.637-20.417-18.265-29.036l-0.365-0.413 l7.029-24.066c0.122-0.416-0.034-0.863-0.388-1.113l-24.016-17.011c-0.352-0.25-0.827-0.25-1.18,0.003l-20.369,14.618 l-0.512-0.208c-10.662-4.335-21.917-6.891-33.451-7.594l-0.552-0.034l-12.053-22.001c-0.209-0.379-0.637-0.585-1.061-0.513 l-29.012,4.953c-0.427,0.073-0.761,0.409-0.831,0.837l-4.069,24.754l-0.509,0.214c-10.647,4.492-20.417,10.637-29.035,18.265 l-0.414,0.366l-24.065-7.03c-0.418-0.123-0.863,0.034-1.113,0.388l-17.011,24.016c-0.251,0.353-0.249,0.827,0.004,1.179 l14.618,20.37l-0.208,0.512c-4.336,10.66-6.892,21.914-7.595,33.451l-0.033,0.551l-22.002,12.053 c-0.38,0.208-0.586,0.635-0.514,1.063l4.953,29.009c0.073,0.427,0.409,0.761,0.837,0.832l24.755,4.07l0.214,0.508 c4.491,10.646,10.637,20.415,18.266,29.036l0.365,0.413l-7.03,24.065c-0.121,0.416,0.034,0.864,0.388,1.114l24.017,17.01 c0.352,0.25,0.825,0.249,1.179-0.003L962.566,488.573z M1003.642,461.994c-14.392,0.001-28.911-4.29-41.523-13.223 c-10.653-7.546-19.047-17.817-24.275-29.703c-0.223-0.506,0.007-1.096,0.513-1.318c0.508-0.224,1.096,0.008,1.317,0.513 c5.083,11.555,13.244,21.54,23.602,28.876c31.503,22.313,75.286,14.836,97.601-16.667c22.313-31.503,14.837-75.287-16.666-97.601 c-31.505-22.313-75.286-14.836-97.6,16.667c-2.888,4.075-5.339,8.451-7.286,13.006c-0.219,0.508-0.805,0.742-1.314,0.526 c-0.508-0.217-0.743-0.805-0.526-1.313c2.004-4.685,4.525-9.186,7.493-13.376c22.952-32.403,67.986-40.092,100.389-17.142 c32.402,22.951,40.093,67.985,17.143,100.389C1048.489,451.419,1026.227,461.991,1003.642,461.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1003.139,417.179c-7.666,0-15.285-3.221-20.644-9.491c-9.721-11.372-8.377-28.532,2.995-38.253 l0,0c11.371-9.719,28.533-8.377,38.253,2.996c4.709,5.509,6.991,12.522,6.425,19.747c-0.566,7.226-3.911,13.798-9.42,18.506 C1015.646,415.045,1009.376,417.179,1003.139,417.179z M986.788,370.955c-10.533,9.004-11.777,24.899-2.775,35.433 c9.004,10.534,24.898,11.779,35.435,2.775c10.533-9.003,11.778-24.899,2.774-35.433 C1013.218,363.195,997.323,361.952,986.788,370.955L986.788,370.955z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1229.518,441.154c-0.081,0-0.163-0.005-0.246-0.016l-14.043-1.773 c-0.833-0.105-1.509-0.728-1.681-1.549l-2.307-11.014c-4.991-1.913-9.629-4.556-13.801-7.864l-10.646,3.62 c-0.798,0.271-1.676,0.007-2.191-0.658l-8.675-11.184c-0.516-0.663-0.553-1.582-0.093-2.285l6.152-9.412 c-2.168-4.866-3.575-10.015-4.187-15.323l-10.094-4.972c-0.754-0.37-1.19-1.179-1.085-2.013l1.774-14.044 c0.105-0.834,0.729-1.509,1.551-1.681l11.012-2.306c1.913-4.99,4.557-9.628,7.865-13.801l-3.62-10.646 c-0.271-0.795-0.007-1.675,0.658-2.191l11.182-8.676c0.664-0.515,1.582-0.553,2.285-0.092l9.412,6.152 c4.863-2.167,10.013-3.574,15.323-4.187l4.971-10.094c0.37-0.754,1.182-1.19,2.014-1.084l14.043,1.773 c0.835,0.105,1.511,0.729,1.682,1.553l2.306,11.011c4.992,1.914,9.63,4.557,13.801,7.864l10.646-3.62 c0.793-0.271,1.674-0.007,2.19,0.657l8.676,11.184c0.515,0.665,0.552,1.583,0.092,2.285l-6.152,9.412 c2.168,4.865,3.575,10.014,4.186,15.322l10.095,4.972c0.754,0.371,1.19,1.18,1.084,2.013l-1.772,14.043 c-0.105,0.834-0.729,1.51-1.552,1.681l-11.012,2.307c-1.913,4.99-4.556,9.627-7.864,13.8l3.62,10.646 c0.27,0.796,0.005,1.676-0.659,2.19l-11.183,8.675c-0.664,0.515-1.58,0.553-2.284,0.093l-9.413-6.152 c-4.865,2.168-10.014,3.574-15.322,4.186l-4.971,10.094C1230.95,440.734,1230.26,441.154,1229.518,441.154z M1197.838,416.69 l0.43,0.348c4.257,3.449,9.03,6.169,14.188,8.085l0.517,0.192l2.532,12.09l14.017,1.749l5.428-11.064l0.549-0.058 c5.471-0.573,10.771-2.021,15.752-4.304l0.502-0.23l10.333,6.754l11.149-8.675l-3.982-11.654l0.347-0.429 c3.449-4.258,6.17-9.032,8.085-14.188l0.193-0.517l12.09-2.532l1.749-14.017l-11.065-5.427l-0.057-0.549 c-0.573-5.47-2.021-10.77-4.305-15.753l-0.23-0.501l6.754-10.334l-8.674-11.148l-11.655,3.984l-0.429-0.348 c-4.256-3.448-9.029-6.169-14.189-8.086l-0.517-0.192l-2.532-12.089l-14.017-1.75l-5.427,11.064l-0.549,0.058 c-5.473,0.574-10.773,2.022-15.753,4.305l-0.502,0.23l-10.315-6.743l-11.166,8.663l3.983,11.654l-0.347,0.429 c-3.45,4.258-6.171,9.032-8.086,14.188l-0.192,0.518l-12.09,2.532l-1.749,14.017l11.065,5.426l0.057,0.549 c0.573,5.47,2.021,10.77,4.305,15.753l0.229,0.501l-6.754,10.333l8.675,11.148L1197.838,416.69z M1197.658,324.159h0.01H1197.658z  M1230.494,412.804c-10.501,0-20.896-4.672-27.815-13.592c-3.906-5.036-6.37-11.024-7.128-17.317 c-0.066-0.548,0.325-1.046,0.874-1.112c0.538-0.067,1.046,0.325,1.112,0.873c0.714,5.935,3.038,11.581,6.722,16.331 c11.205,14.443,32.075,17.08,46.518,5.874c6.998-5.428,11.462-13.256,12.571-22.042c1.109-8.786-1.268-17.479-6.697-24.476 c-5.429-6.997-13.257-11.461-22.043-12.571c-8.789-1.11-17.479,1.269-24.475,6.698c-1.868,1.449-3.581,3.094-5.092,4.892 c-0.354,0.422-0.985,0.479-1.409,0.122c-0.423-0.355-0.478-0.986-0.122-1.409c1.602-1.906,3.417-3.65,5.398-5.185 c7.418-5.756,16.634-8.278,25.951-7.102c9.316,1.176,17.616,5.91,23.372,13.329c5.756,7.419,8.278,16.636,7.102,25.952 c-1.176,9.316-5.91,17.617-13.329,23.372C1245.608,410.401,1238.024,412.804,1230.494,412.804z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1386.655,1514.982c2.871,0,5.603-1.625,6.809-4.34l155.38-349.695 c1.617-3.639-0.119-7.857-3.878-9.423c-3.756-1.565-8.115,0.114-9.733,3.754l-155.38,349.695 c-1.617,3.639,0.119,7.858,3.878,9.423C1384.685,1514.793,1385.678,1514.982,1386.655,1514.982z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1706.138,1514.982c-2.871,0-5.604-1.625-6.809-4.34l-155.38-349.695 c-1.617-3.639,0.119-7.857,3.878-9.423c3.756-1.565,8.115,0.114,9.733,3.754l155.38,349.695 c1.617,3.639-0.119,7.858-3.878,9.423C1708.108,1514.793,1707.115,1514.982,1706.138,1514.982z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1553.078,1530.869c-2.644-1.119-4.527-3.68-4.58-6.65l-6.844-382.6 c-0.071-3.981,3.172-7.19,7.243-7.167c4.069,0.022,7.429,3.267,7.501,7.25l6.844,382.6c0.071,3.981-3.172,7.19-7.243,7.167 C1554.967,1531.462,1553.978,1531.249,1553.078,1530.869z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1563.345,1146.145c0,6.65-6.836,10.855-13.855,10.855h-0.083c-7.019,0-10.063-4.204-10.063-10.855 v-102.41c0-6.65,3.044-12.736,10.063-12.736h0.083c7.018,0,13.855,6.085,13.855,12.736V1146.145z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016035174100382923530000012160169475334604427_",
    gradientUnits: "userSpaceOnUse",
    x1: 1504.5798,
    y1: 1039.6975,
    x2: 1568.1979,
    y2: 1039.6975
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016035174100382923530000012160169475334604427_)"
    },
    d: "M1504.58,1017l1.829,26.905 c0.165,2.445,2.196,4.095,4.647,4.095h15.289v8.578c0,3.653-0.184,5.422,3.469,5.422h9.885l20.234,0.395l8.264-45.395H1504.58z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025438560300550246550000000131920076284499365_",
    gradientUnits: "userSpaceOnUse",
    x1: 1569.2566,
    y1: 1028.7083,
    x2: 1560.2571,
    y2: 1133.703
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025438560300550246550000000131920076284499365_)"
    },
    d: "M1528.825,1017l10.5,45.595 l33.095,0.56c3.363,0.064,6.238-2.443,6.683-5.777l1.469-11.041l11.331,0.16c7.992,0.119,14.93-5.335,16.498-13.173 l3.294-16.324H1528.825z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171707557094798031540000001222111920022820525_",
    gradientUnits: "userSpaceOnUse",
    x1: 1508.4584,
    y1: 955,
    x2: 1626.6949,
    y2: 955
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171707557094798031540000001222111920022820525_)"
    },
    d: "M1537.629,889h-17.559 c-6.008,0-10.952,3.481-11.217,9.483L1508.201,912h-41.876c-10.048,0-18.233,8.672-18.372,18.719l-0.989,71.546 c-0.068,4.917,1.837,9.709,5.29,13.21c3.453,3.501,8.165,5.525,13.082,5.525h11.368h88.495L1537.629,889z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135673031894043521280000005772704521559930278_",
    gradientUnits: "userSpaceOnUse",
    x1: 1587.0741,
    y1: 854.8879,
    x2: 1563.0754,
    y2: 1052.8783
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135673031894043521280000005772704521559930278_)"
    },
    d: "M1661.615,1001.801l-3.958-71.846 c-0.541-9.737-8.594-17.955-18.346-17.955h-50.967v-15.346c0-3.1-3.105-6.061-5.365-8.183c-2.259-2.122-6.207-3.216-9.301-3.022 l-31.714,1.958c-3.213,0.201-6.413,1.772-8.389,4.313c-1.976,2.541-2.881,5.208-2.284,8.372l2.243,11.909h-32.46 c-10.148,0-15.732,9.426-15.732,19.574v71.246c0,10.148,5.584,18.18,15.732,18.18h142.193c5.05,0,9.877-1.981,13.348-5.65 C1660.088,1011.682,1661.896,1006.843,1661.615,1001.801z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173876548699421298510000004154665738010907031_",
    gradientUnits: "userSpaceOnUse",
    x1: 1591.8589,
    y1: 914.6805,
    x2: 1432.0247,
    y2: 1097.7168
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173876548699421298510000004154665738010907031_)"
    },
    d: "M1594.591,940.921 c-2.132-2.429-5.207-3.921-8.439-3.921h-77.224c-6.201,0-11.584,5.226-11.584,11.426v40.542c0,6.201,5.383,11.032,11.584,11.032 h71.915c5.637,0,10.401-4.082,11.132-9.672l5.309-40.543C1597.705,946.581,1596.723,943.35,1594.591,940.921z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.24
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1547.042,910.665c-2.558,0-4.785-1.821-5.297-4.328l-0.642-3.148 c-0.326-1.597,0.079-4.088,1.11-5.352c1.031-1.263,2.557-2.837,4.188-2.837h22.387c2.982,0,7.555,4.127,7.555,7.109v0.892 c0,2.78-3.159,5.093-5.923,5.379l-22.283,2.256C1547.951,910.656,1547.227,910.665,1547.042,910.665z M1546.402,897 c-1.179,0-2.281,1.123-3.026,2.036c-0.745,0.913-1.038,2.399-0.803,3.554l0.642,3.298c0.397,1.942,2.216,3.375,4.233,3.182 l23.569-2.218c1.998-0.208,5.328-1.842,5.328-3.85v-0.892c0-2.155-5.4-5.109-7.555-5.109H1546.402z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057862028454390291660000001003820918715686808_",
    gradientUnits: "userSpaceOnUse",
    x1: 1573.4478,
    y1: 949.0732,
    x2: 1583.197,
    y2: 949.0732
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057862028454390291660000001003820918715686808_)"
    },
    d: "M1583.197,949.073 c0,2.692-2.182,4.875-4.875,4.875s-4.875-2.182-4.875-4.875c0-2.692,2.182-4.875,4.875-4.875S1583.197,946.381,1583.197,949.073z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011717614093396058530000014520881408710526867_",
    gradientUnits: "userSpaceOnUse",
    x1: 1585.8246,
    y1: 796.2153,
    x2: 1615.8246,
    y2: 924.2153
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#090056"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011717614093396058530000014520881408710526867_)"
    },
    d: "M1619.029,978 c0-2,0.658-13.276,1.783-13.651c1.125-0.375,17.532-0.152,17.532-0.152V978h10v12h-14.15l0.75,8h-14.624l0.575-10.339l-9.55,2.41 V978H1619.029z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093891108079438154150000014506306625742015136_",
    gradientUnits: "userSpaceOnUse",
    x1: 1593.2924,
    y1: 794.4653,
    x2: 1623.2924,
    y2: 922.4655
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#090056"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000093891108079438154150000014506306625742015136_)"
    },
    cx: 1628.445,
    cy: 944.448,
    r: 10.499
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011013528864130765450000001957418701738965124_",
    gradientUnits: "userSpaceOnUse",
    x1: 1596.9204,
    y1: 1036.8992,
    x2: 1557.9204,
    y2: 1111.8993
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011013528864130765450000001957418701738965124_)"
    },
    d: "M1580.345,1151.158 c0,6.091-8.743,9.842-15.647,9.842h-57.497c-6.903,0-11.856-3.751-11.856-9.842v-0.441c0-6.091,4.953-9.717,11.856-9.717h57.497 c6.903,0,15.647,3.626,15.647,9.717V1151.158z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168833660103134678230000014858404474373603006_",
    gradientUnits: "userSpaceOnUse",
    x1: 1369.7876,
    y1: 1185.5818,
    x2: 2444.4338,
    y2: 982.3757
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168833660103134678230000014858404474373603006_)"
    },
    d: "M1594.345,1151.446 c0,6.244-6.245,9.554-13.148,9.554H1523.7c-6.903,0-9.355-3.309-9.355-9.554v-0.452c0-6.244,2.452-9.994,9.355-9.994h57.497 c6.903,0,13.148,3.75,13.148,9.994V1151.446z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1593.697,1031.694c1.52-0.434,50.997,41.998,50.997,41.998l-8,3.727l-48.497-34.725 C1588.197,1042.693,1583.197,1034.694,1593.697,1031.694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1643.697,1067.924c-2.372-1.563-5.481-1.438-7.718,0.313c-3.924,3.073-8.453,8.215-2.347,12.539 c9.399,6.656,49.218,38.958,54.737,34.74C1693.778,1111.381,1703.035,1107.031,1643.697,1067.924z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088130074093209185570000007648913064804353211_",
    gradientUnits: "userSpaceOnUse",
    x1: 1006.9246,
    y1: 704.2228,
    x2: 1254.8962,
    y2: 704.2228
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088130074093209185570000007648913064804353211_)"
    },
    d: "M1077.796,832.18 c0,0,239.754-118.46,161.346-205.68c-78.408-87.219-224.586-52.357-231.991,39.441 C999.745,757.74,1177.663,736.203,1077.796,832.18z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1218.86,650.027h-105.81c-0.553,0-1-0.448-1-1c0-0.552,0.447-1,1-1h105.81c0.553,0,1,0.448,1,1 C1219.86,649.579,1219.413,650.027,1218.86,650.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1081.631,650.027h-31.396c-0.553,0-1-0.448-1-1c0-0.552,0.447-1,1-1h31.396c0.553,0,1,0.448,1,1 C1082.631,649.579,1082.184,650.027,1081.631,650.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1222.425,671.449h-39.732c-0.553,0-1-0.448-1-1s0.447-1,1-1h39.732c0.553,0,1,0.448,1,1 S1222.978,671.449,1222.425,671.449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1124.396,671.449H1053.8c-0.553,0-1-0.448-1-1s0.447-1,1-1h70.596c0.553,0,1,0.448,1,1 S1124.948,671.449,1124.396,671.449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1225.989,692.871h-105.615c-0.553,0-1-0.448-1-1c0-0.552,0.447-1,1-1h105.615 c0.553,0,1,0.448,1,1C1226.989,692.423,1226.542,692.871,1225.989,692.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1093.927,692.871h-36.563c-0.553,0-1-0.448-1-1c0-0.552,0.447-1,1-1h36.563c0.553,0,1,0.448,1,1 C1094.927,692.423,1094.48,692.871,1093.927,692.871z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105398860112888753750000009399878640044724653_",
    gradientUnits: "userSpaceOnUse",
    x1: 854.4203,
    y1: 1052.0846,
    x2: 872.4195,
    y2: 1202.0769
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105398860112888753750000009399878640044724653_)"
    },
    d: "M849.392,1137.32l29.489,1.646 l6.589,78.56c0,0,6.439,6.366,6.102,20.794c-0.337,14.428-1.87,15.871-4.035,13.978c-2.164-1.894-1.623-9.469-4.599-11.904 c-2.976-2.435-4.87,7.007-2.435,12.566c2.435,5.56,11.633,32.342,2.705,23.956c-8.928-8.387-16.773-22.454-17.314-35.17 c-0.541-12.715,2.976-22.184,2.976-22.184L849.392,1137.32z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025424365402283887960000008801512792605972924_",
    gradientUnits: "userSpaceOnUse",
    x1: -8604.0078,
    y1: 1476.1993,
    x2: -8794.3223,
    y2: 1625.6351,
    gradientTransform: "matrix(-1 0 0 1 -7708.2041 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025424365402283887960000008801512792605972924_)"
    },
    d: "M958.075,1514.364 c12.798-0.358,19.418-1.865,22.84-3.264c0.008,1.273,0.001,2.568-0.04,3.909c-0.044,1.433-1.106,2.578-2.411,2.569l-70.27-0.453 c-2.243-0.015-3.553-2.615-2.581-4.672C914.826,1513.215,938.292,1514.918,958.075,1514.364z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011717775857409026090000006546365321128285834_",
    gradientUnits: "userSpaceOnUse",
    x1: 7009.7031,
    y1: 1513.0253,
    x2: 7178.1045,
    y2: 1457.4984,
    gradientTransform: "matrix(1 0 0 1 -6096.875 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011717775857409026090000006546365321128285834_)"
    },
    d: "M977.347,1487.421 c-1.609-5.714-6.885-9.591-12.818-9.404l-5.868,0.186c-31.232,7.489-47.039,24.756-53.244,33.427 c-0.121,0.168-0.193,0.351-0.278,0.53c9.214,0.761,32.679,2.464,52.463,1.911c12.798-0.358,19.418-1.865,22.84-3.264 C980.383,1500.815,978.909,1492.963,977.347,1487.421z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170975176108568288140000016772302835975701379_",
    gradientUnits: "userSpaceOnUse",
    x1: 7059.9761,
    y1: 1435.301,
    x2: 7049.9834,
    y2: 1522.5099,
    gradientTransform: "matrix(1 0 0 1 -6096.875 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170975176108568288140000016772302835975701379_)"
    },
    d: "M949.362,1458.042l4.908,23.627 c0.36,1.731,1.69,3.028,3.301,3.179c1.972,0.185,4.78,0.294,7.603-0.121c2.532-0.372,4.295-2.945,3.846-5.706l-3.411-20.978 H949.362z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137824795270539648040000016335234623258087067_",
    gradientUnits: "userSpaceOnUse",
    x1: 7210.1982,
    y1: 1476.1995,
    x2: 7019.8838,
    y2: 1625.6349,
    gradientTransform: "matrix(1 0 0 1 -6096.875 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137824795270539648040000016335234623258087067_)"
    },
    d: "M1051.051,1514.364 c-12.798-0.358-19.418-1.865-22.84-3.264c-0.008,1.273-0.001,2.568,0.04,3.909c0.044,1.433,1.106,2.578,2.412,2.569l70.27-0.453 c2.242-0.015,3.553-2.615,2.581-4.672C1094.301,1513.215,1070.835,1514.918,1051.051,1514.364z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059297436574059509750000007914277425655833239_",
    gradientUnits: "userSpaceOnUse",
    x1: 7130.6143,
    y1: 1506.9512,
    x2: 7287.4443,
    y2: 1455.2397,
    gradientTransform: "matrix(1 0 0 1 -6096.875 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059297436574059509750000007914277425655833239_)"
    },
    d: "M1103.515,1512.453 c-0.085-0.179-0.157-0.361-0.278-0.53c-6.206-8.671-22.012-25.938-53.245-33.427l-14.983-0.473c0,0-6.672,11.596-6.798,33.076 c3.422,1.399,10.042,2.906,22.84,3.264C1070.835,1514.918,1094.301,1513.215,1103.515,1512.453z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107547667370338439450000008323288018033737114_",
    gradientUnits: "userSpaceOnUse",
    x1: 7141.373,
    y1: 1444.6276,
    x2: 7131.3804,
    y2: 1531.837,
    gradientTransform: "matrix(1 0 0 1 -6096.875 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107547667370338439450000008323288018033737114_)"
    },
    d: "M1032.23,1455.317 c0.167,1.116,2.22,18.091,3.015,24.672c0.189,1.564,1.322,2.774,2.75,2.945c2.551,0.304,6.68,0.582,10.292-0.158 c1.949-0.4,3.359-2.271,3.359-4.448v-26.645L1032.23,1455.317z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096742408781071944640000017893610721215855775_",
    gradientUnits: "userSpaceOnUse",
    x1: 984.4945,
    y1: 1417.6169,
    x2: 1003.9932,
    y2: 1083.1349
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6064,
    style: {
      stopColor: "#13097D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096742408781071944640000017893610721215855775_)"
    },
    d: "M1020.21,1145.543 c0,0,36.138,137.339,35.485,310.166c-0.012,3.151-2.224,5.87-5.308,6.52c-4.544,0.957-11.223,2.093-16.752,1.938 c-2.952-0.083-5.419-2.272-5.916-5.183c-5.067-29.715-34.147-197.118-50.715-224.296c0,0-10.901,149.097-7.416,226.448 c0.087,1.923-1.322,3.592-3.234,3.813c-2.901,0.335-7.542,0.59-13.449-0.037c-2.242-0.238-4.051-1.933-4.372-4.165 c-3.609-25.149-24.384-174.846-23.5-282.682c0.05-6.081,16.082-32.522,16.082-32.522H1020.21z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158024882096680204870000015163168071027505056_",
    gradientUnits: "userSpaceOnUse",
    x1: 7082.0513,
    y1: 876.7955,
    x2: 7043.8975,
    y2: 1041.6743,
    gradientTransform: "matrix(1 0 0 1 -6096.875 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158024882096680204870000015163168071027505056_)"
    },
    d: "M956.346,889.635l-4.697,47.991 c0,0,26.998,8.132,46.634-5.723l-13.804-43.617L956.346,889.635z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017487672590908514890000010829696212340294784_",
    gradientUnits: "userSpaceOnUse",
    x1: 5735.1831,
    y1: 3098.8682,
    x2: 5774.1812,
    y2: 3016.3723,
    gradientTransform: "matrix(0.9808 0.1949 -0.1949 0.9808 -6054.1704 -559.1375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017487672590908514890000010829696212340294784_)"
    },
    d: "M1006.922,843.482 c0,0,7.211,33.11,4.924,49.281c-2.287,16.172-0.903,27.235-20.037,26.781c-19.134-0.454-32.883-12.762-38.158-30.372 c0,0-8.346-27.178-3.382-36.643C955.232,843.065,1006.922,843.482,1006.922,843.482z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166665284052877983910000001763252065290571675_",
    gradientUnits: "userSpaceOnUse",
    x1: 7147.6206,
    y1: -20.0119,
    x2: 7219.6338,
    y2: 72.7046,
    gradientTransform: "matrix(0.9808 0.1949 -0.1949 0.9808 -6054.1704 -559.1375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6064,
    style: {
      stopColor: "#13097D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166665284052877983910000001763252065290571675_)"
    },
    d: "M962.246,878.973l1.145-0.255 c1.458-0.324,2.348-1.806,1.933-3.241c-1.607-5.557-4.396-18.114,2.707-19.503c9.154-1.79,44.041-1.965,53.639-12.425 c9.224-10.052,5.997-26.036-2.427-32.073c-0.563-0.404-1.338-0.326-1.775,0.212l-1.062,1.307 c-0.726,0.894-2.172,0.45-2.271-0.698l0,0c-0.094-1.102-1.441-1.58-2.198-0.774c-2.931,3.117-10.081,7.695-26.723,7.468 c-23.653-0.323-40.571,5.913-44.079,21.605c-0.223,0.997-1.399,1.342-2.151,0.651c-1.481-1.362-4.081-2.379-8.286-0.065 c-7.313,4.024-7.464,18.201,4.038,32.172c0.546,0.664,0.338,1.682-0.46,2.001c-2.812,1.127-7.291,4.246,1.306,11.299 c8.893,7.295,16.409,8.335,19.363,8.431c0.735,0.024,1.33-0.574,1.315-1.309l-0.3-14.464c-0.017-0.818,0.728-1.443,1.531-1.283 L962.246,878.973z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167395093775524421360000010000697983681823675_",
    gradientUnits: "userSpaceOnUse",
    x1: 5714.3174,
    y1: 3089.0073,
    x2: 5753.3154,
    y2: 3006.5115,
    gradientTransform: "matrix(0.9808 0.1949 -0.1949 0.9808 -6054.1704 -559.1375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167395093775524421360000010000697983681823675_)"
    },
    d: "M962.24,882.011 c0,0-1.193-20.472-11.005-16.748c-9.812,3.724,0.195,22.711,7.067,24.834L962.24,882.011z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076561264295268048760000002688232944816143505_",
    gradientUnits: "userSpaceOnUse",
    x1: 1079.3282,
    y1: 936.2838,
    x2: 805.3287,
    y2: 1216.2833
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076561264295268048760000002688232944816143505_)"
    },
    d: "M946.946,932.995 c0,0-64.066-9.252-46.664,71.844c17.402,81.096,28.768,123.691,32.044,157.276c11.468,7.372,84.972-0.055,87.81-1.445 c2.839-1.39,3.909,1.726,3.725-12.748c-0.184-14.474,23.709-131.532,25.641-138.441c1.932-6.909,58.838,78.393,50.647,27.865 c-8.192-50.528-49.882-114.996-95.388-111.023C959.256,930.296,946.946,932.995,946.946,932.995z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010268717684396324030000006338261684972489600_",
    gradientUnits: "userSpaceOnUse",
    x1: 1138.3799,
    y1: 954.1777,
    x2: 904.1036,
    y2: 1283.4747
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010268717684396324030000006338261684972489600_)"
    },
    d: "M1049.503,1009.481 c0,0,49.008,58.022,55.562,58.022c6.553,0,12.017-21.765,12.017-21.765l-33.789-57.85L1049.503,1009.481z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072958736872642572660000002998742602417808017_",
    gradientUnits: "userSpaceOnUse",
    x1: 1035.689,
    y1: 893.5795,
    x2: 761.6888,
    y2: 1173.5796
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072958736872642572660000002998742602417808017_)"
    },
    d: "M927.061,934.92 c-2.16-1.971-74.716,10.72-74.716,150.794c0,51.606,0,51.606,0,51.606l28.013,1.646l33.585-117.981 C913.943,1020.985,946.732,952.87,927.061,934.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148656669047765082290000005077927828732565376_",
    gradientUnits: "userSpaceOnUse",
    x1: 1144.7717,
    y1: 825.0935,
    x2: 1129.7722,
    y2: 1018.5847
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148656669047765082290000005077927828732565376_)"
    },
    d: "M1158.833,930.698 c-0.811-14.081-7.25-22.461-13.786-27.4c-1.204-0.91-2.408-1.72-3.612-2.408c-5.701-3.318-10.592-4.202-10.592-4.202 c-4.006-6.144-4.35,36.075-4.35,36.075l0.025,0.049c-0.393,0.491-0.762,1.007-1.106,1.523c-0.098-0.933-0.098-1.965,0.025-3.072 c0.835-7.79-5.112-9.265-5.112-7.422c0,1.843-2.458,13.639-3.244,18.357c-0.737,4.423,12.165,20.912,13.737,22.903 c0,0.024,0.025,0.049,0.025,0.049c0.074,0.295,0.123,0.467,0.123,0.467s-31.16,100.043-27.843,101.886 c1.695,0.959,23.837,18.431,32.758,9.019c8.134-8.626,14.302-96.062,15.31-111.224c0,0,5.75-3.932,7.323-20.298 c0.025-0.049,0.025-0.074,0.025-0.123c0.197-0.811,0.295-1.475,0.295-1.991c0-0.27-0.025-0.565-0.074-0.86 C1158.98,938.734,1159.005,934.949,1158.833,930.698z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1512.748,420.4c0,0,1.191,0.311,2.402,0.588c1.214,0.27,2.427,0.539,2.427,0.539l0.013,0.003 c0.411,0.091,0.671,0.499,0.58,0.91c-0.092,0.411-0.499,0.671-0.91,0.579c0,0-1.227-0.272-2.454-0.543 c-1.225-0.28-2.454-0.6-2.454-0.6c-0.408-0.106-0.653-0.524-0.547-0.932c0.107-0.408,0.524-0.653,0.932-0.547l0.001,0 L1512.748,420.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1522.451,422.494l4.927,0.848c0.414,0.071,0.692,0.465,0.621,0.879 c-0.071,0.414-0.465,0.692-0.879,0.621l-4.927-0.846c-0.415-0.071-0.693-0.465-0.622-0.88 C1521.642,422.701,1522.036,422.423,1522.451,422.494L1522.451,422.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1532.29,424.072l4.96,0.628c0.416,0.053,0.71,0.432,0.657,0.848 c-0.052,0.416-0.432,0.71-0.847,0.657l-4.96-0.625c-0.416-0.052-0.711-0.432-0.659-0.849S1531.873,424.02,1532.29,424.072 L1532.29,424.072z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1542.19,425.218l4.982,0.417c0.416,0.035,0.725,0.401,0.69,0.817 c-0.035,0.416-0.4,0.725-0.816,0.69l-4.982-0.415c-0.417-0.035-0.726-0.401-0.692-0.818 C1541.407,425.493,1541.773,425.184,1542.19,425.218L1542.19,425.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1552.13,425.946l4.995,0.207c0.416,0.017,0.739,0.368,0.722,0.784 c-0.017,0.416-0.368,0.739-0.784,0.722l-4.995-0.204c-0.417-0.017-0.74-0.369-0.724-0.785 C1551.361,426.253,1551.713,425.929,1552.13,425.946L1552.13,425.946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1562.09,426.251l5-0.011c0.415-0.001,0.753,0.335,0.753,0.75c0.001,0.415-0.334,0.752-0.749,0.753 l-5,0.013c-0.416,0.001-0.754-0.335-0.755-0.751C1561.338,426.591,1561.674,426.253,1562.09,426.251L1562.09,426.251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1572.054,426.119l4.994-0.237c0.413-0.02,0.764,0.299,0.784,0.713 c0.02,0.413-0.299,0.765-0.713,0.784l-4.994,0.24c-0.414,0.02-0.766-0.3-0.786-0.714 C1571.32,426.491,1571.64,426.139,1572.054,426.119L1572.054,426.119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1581.999,425.529l4.977-0.476c0.411-0.039,0.775,0.262,0.815,0.673 c0.04,0.411-0.261,0.776-0.672,0.815l-4.977,0.478c-0.411,0.04-0.777-0.262-0.816-0.673 C1581.286,425.935,1581.587,425.569,1581.999,425.529L1581.999,425.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1591.902,424.458l4.946-0.728c0.407-0.06,0.786,0.221,0.846,0.628 c0.06,0.407-0.221,0.785-0.628,0.845l-4.946,0.73c-0.407,0.06-0.787-0.221-0.847-0.629 C1591.213,424.898,1591.494,424.518,1591.902,424.458L1591.902,424.458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1601.735,422.878l4.9-0.993c0.402-0.082,0.794,0.178,0.875,0.58 c0.082,0.402-0.178,0.794-0.58,0.875l-4.899,0.996c-0.403,0.082-0.795-0.178-0.877-0.581 C1601.072,423.353,1601.332,422.96,1601.735,422.878L1601.735,422.878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1611.463,420.763l4.835-1.273c0.395-0.104,0.8,0.132,0.905,0.527 c0.104,0.395-0.132,0.8-0.527,0.905l-4.834,1.275c-0.396,0.105-0.802-0.132-0.906-0.528 C1610.83,421.273,1611.066,420.868,1611.463,420.763L1611.463,420.763z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1621.048,418.085l4.748-1.566c0.387-0.128,0.804,0.083,0.932,0.47 c0.128,0.387-0.083,0.804-0.469,0.932l-4.748,1.568c-0.388,0.128-0.806-0.082-0.934-0.47 C1620.45,418.631,1620.66,418.213,1621.048,418.085L1621.048,418.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1630.448,414.819l4.638-1.869c0.377-0.152,0.806,0.03,0.957,0.407 c0.152,0.377-0.03,0.805-0.407,0.957l-4.636,1.871c-0.377,0.152-0.807-0.03-0.959-0.407 C1629.888,415.401,1630.07,414.971,1630.448,414.819L1630.448,414.819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1639.612,410.946l4.5-2.18c0.365-0.177,0.804-0.024,0.98,0.34c0.177,0.365,0.025,0.803-0.34,0.98 l-4.499,2.182c-0.365,0.177-0.804,0.025-0.982-0.34C1639.094,411.562,1639.246,411.123,1639.612,410.946L1639.612,410.946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1648.486,406.454l4.334-2.493c0.35-0.201,0.797-0.081,0.999,0.269 c0.201,0.35,0.081,0.797-0.269,0.998l-4.333,2.494c-0.35,0.202-0.798,0.081-1-0.269 C1648.014,407.104,1648.135,406.656,1648.486,406.454L1648.486,406.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1657.026,401.336c0,0,0.261-0.171,0.654-0.428c0.385-0.262,0.898-0.61,1.411-0.959 c1.034-0.703,2.068-1.405,2.068-1.405c0.333-0.226,0.786-0.14,1.013,0.193c0.226,0.333,0.139,0.787-0.194,1.013 c0,0-1.033,0.703-2.067,1.406c-0.521,0.354-1.041,0.708-1.431,0.973c-0.392,0.257-0.653,0.428-0.653,0.428 c-0.337,0.221-0.79,0.127-1.011-0.211C1656.593,402.009,1656.688,401.557,1657.026,401.336L1657.026,401.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1665.195,395.652l4.002-2.997c0.321-0.241,0.777-0.175,1.017,0.146 c0.241,0.321,0.175,0.777-0.146,1.017l-4,2.999c-0.322,0.241-0.778,0.176-1.019-0.146S1664.873,395.893,1665.195,395.652 L1665.195,395.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1673.122,389.6l3.894-3.137c0.312-0.251,0.768-0.202,1.019,0.11 c0.251,0.312,0.202,0.768-0.109,1.019l-3.892,3.139c-0.312,0.251-0.769,0.202-1.021-0.109 C1672.761,390.308,1672.81,389.851,1673.122,389.6L1673.122,389.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1680.839,383.278l3.789-3.262c0.302-0.26,0.758-0.226,1.019,0.076 c0.26,0.302,0.226,0.758-0.076,1.018l-3.788,3.264c-0.302,0.261-0.759,0.227-1.02-0.076 C1680.502,383.996,1680.536,383.539,1680.839,383.278L1680.839,383.278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1688.345,376.707l3.678-3.388c0.292-0.27,0.748-0.251,1.017,0.042 c0.27,0.292,0.251,0.748-0.041,1.017l-3.676,3.39c-0.293,0.27-0.749,0.251-1.019-0.041 C1688.034,377.434,1688.052,376.977,1688.345,376.707L1688.345,376.707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1695.62,369.884l3.551-3.521c0.281-0.279,0.736-0.277,1.015,0.004 c0.279,0.281,0.277,0.736-0.004,1.015l-3.549,3.523c-0.282,0.28-0.737,0.278-1.017-0.004 C1695.337,370.619,1695.339,370.164,1695.62,369.884L1695.62,369.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1702.628,362.793l3.4-3.668c0.268-0.29,0.721-0.307,1.011-0.039 c0.29,0.268,0.307,0.721,0.039,1.011l-3.398,3.669c-0.269,0.29-0.722,0.308-1.013,0.039 C1702.377,363.537,1702.359,363.084,1702.628,362.793L1702.628,362.793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1709.314,355.405l3.21-3.834c0.253-0.302,0.702-0.342,1.005-0.09 c0.302,0.253,0.342,0.702,0.089,1.005l-3.208,3.835c-0.253,0.303-0.703,0.343-1.006,0.09 C1709.101,356.158,1709.06,355.708,1709.314,355.405L1709.314,355.405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1715.591,347.679l2.963-4.027c0.232-0.316,0.677-0.384,0.994-0.152 c0.316,0.232,0.384,0.678,0.152,0.994l-2.962,4.029c-0.233,0.317-0.678,0.385-0.995,0.153 C1715.426,348.443,1715.358,347.997,1715.591,347.679L1715.591,347.679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1721.345,339.564l2.618-4.256c0.205-0.333,0.638-0.437,0.971-0.232 c0.333,0.205,0.435,0.642,0.23,0.975l-2.624,4.257c-0.205,0.334-0.635,0.438-0.969,0.233c-0.334-0.205-0.226-0.642-0.226-0.976 V339.564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1726.331,330.974c0,0,0.567-1.103,1.095-2.224c0.531-1.119,1.019-2.256,1.019-2.256 c0.154-0.359,0.569-0.525,0.927-0.371c0.359,0.154,0.524,0.571,0.37,0.929c0,0-0.497,1.161-1.038,2.301 c-0.536,1.141-1.112,2.263-1.112,2.263l-0.003,0.005c-0.179,0.348-0.605,0.485-0.953,0.306 C1726.289,331.748,1726.152,331.322,1726.331,330.974L1726.331,330.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1730.221,321.883c0,0,0.4-1.169,0.739-2.356c0.344-1.184,0.621-2.384,0.621-2.384 c0.087-0.379,0.465-0.615,0.844-0.528c0.379,0.087,0.615,0.468,0.527,0.847c0,0-0.285,1.237-0.639,2.454 c-0.346,1.218-0.756,2.415-0.756,2.415l-0.003,0.008c-0.126,0.369-0.527,0.565-0.895,0.439 C1730.292,322.653,1730.095,322.252,1730.221,321.883L1730.221,321.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1732.345,312.303c0,0,0.067-0.306,0.113-0.766c0.042-0.458,0.104-1.07,0.129-1.682 c0.056-1.224,0.021-2.447,0.021-2.447c-0.014-0.387,0.293-0.713,0.68-0.727c0.387-0.014,0.715,0.293,0.729,0.68 c0,0,0.048,1.277-0.01,2.552c-0.026,0.637-0.07,1.273-0.113,1.749c-0.047,0.474-0.078,0.789-0.078,0.789 c-0.038,0.386-0.382,0.512-0.769,0.474c-0.386-0.038-0.704,0.075-0.666-0.925h-0.036V312.303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1732.062,302.564c0,0-0.064-0.299-0.161-0.749c-0.101-0.446-0.251-1.037-0.423-1.622 c-0.338-1.172-0.79-2.305-0.79-2.305c-0.144-0.359,0.031-0.766,0.39-0.909c0.359-0.143,0.766,0.031,0.909,0.39l0.002,0.006 c0,0,0.477,1.191,0.832,2.423c0.181,0.615,0.339,1.236,0.445,1.704c0.101,0.467,0.168,0.779,0.168,0.779 c0.081,0.378-0.159,0.751-0.537,0.833c-0.378,0.082-0.751-0.159-0.833-0.537l0,0L1732.062,302.564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1728.521,293.549c0,0-0.171-0.261-0.429-0.653c-0.129-0.196-0.279-0.424-0.44-0.669 c-0.077-0.114-0.157-0.232-0.238-0.351l-0.262-0.347c-0.719-0.934-1.637-1.699-1.637-1.699c-0.296-0.247-0.336-0.686-0.089-0.982 c0.246-0.296,0.686-0.336,0.982-0.089l0.015,0.012c0,0,1.015,0.843,1.827,1.895l0.3,0.398c0.092,0.135,0.182,0.268,0.269,0.396 c0.161,0.245,0.311,0.473,0.44,0.669c0.258,0.392,0.429,0.653,0.429,0.653c0.212,0.322,0.122,0.755-0.2,0.967 C1729.166,293.961,1728.733,293.872,1728.521,293.549L1728.521,293.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1721.45,287.328c0,0-0.281-0.118-0.702-0.294c-0.421-0.17-0.992-0.378-1.571-0.562 c-1.158-0.375-2.354-0.633-2.354-0.633c-0.375-0.081-0.614-0.451-0.533-0.826c0.081-0.375,0.451-0.614,0.826-0.533l0.008,0.002 c0,0,1.251,0.269,2.474,0.665c0.612,0.194,1.217,0.415,1.665,0.595c0.443,0.186,0.739,0.309,0.739,0.309 c0.355,0.148,0.522,0.556,0.373,0.911c-0.149,0.355-0.556,0.522-0.911,0.373l0,0L1721.45,287.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1711.981,285c0,0-1.225-0.025-2.457-0.034c-1.229-0.017-2.458,0.081-2.458,0.081 c-0.382,0.02-0.708-0.257-0.728-0.639c-0.02-0.382,0.278-0.7,0.661-0.72c0,0,1.269-0.062,2.541-0.045 c0.636,0.007,1.271,0.032,1.748,0.058c0.475,0.03,0.791,0.051,0.791,0.051c0.382,0.024,0.673,0.285,0.649,0.667 c-0.024,0.383-0.353,0.581-0.736,0.581C1711.989,285,1711.983,285,1711.981,285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1702.178,285.603c0,0-1.215,0.197-2.414,0.476c-1.199,0.27-2.374,0.625-2.374,0.625 c-0.365,0.11-0.751-0.096-0.861-0.461c-0.11-0.365,0.1-0.752,0.465-0.862c0,0,1.22-0.369,2.461-0.649 c1.236-0.289,2.491-0.493,2.491-0.493l0.01-0.002c0.377-0.061,0.733,0.195,0.794,0.572 C1702.811,285.186,1702.555,285.542,1702.178,285.603L1702.178,285.603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1692.826,288.446c0,0-0.274,0.136-0.685,0.341c-0.406,0.209-0.939,0.5-1.457,0.816 c-1.042,0.624-1.98,1.378-1.98,1.378c-0.296,0.238-0.729,0.191-0.968-0.106c-0.238-0.296-0.191-0.73,0.106-0.968l0.003-0.003 c0,0,1.015-0.815,2.122-1.478c0.55-0.336,1.114-0.645,1.542-0.865c0.428-0.213,0.714-0.356,0.714-0.356 c0.341-0.17,0.755-0.031,0.925,0.309c0.17,0.341,0.031,0.755-0.31,0.924l0,0L1692.826,288.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1685.564,294.506c0,0-0.151,0.265-0.376,0.662c-0.218,0.398-0.491,0.937-0.733,1.49 c-0.495,1.103-0.823,2.263-0.823,2.263c-0.103,0.365-0.482,0.577-0.847,0.474c-0.365-0.103-0.577-0.482-0.474-0.847l0.002-0.008 c0,0,0.353-1.252,0.883-2.435c0.259-0.593,0.551-1.17,0.783-1.595c0.237-0.418,0.395-0.697,0.395-0.697 c0.187-0.33,0.606-0.446,0.937-0.259c0.33,0.187,0.446,0.607,0.258,0.937v0L1685.564,294.506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1683.345,303.664c0,0-0.195,0.304-0.189,0.759c0.014,0.452-0.045,1.055,0.027,1.655 c0.137,1.202,0.377,2.383,0.377,2.383c0.09,0.367-0.159,0.737-0.526,0.827c-0.367,0.09-0.749-0.134-0.839-0.501l-0.009-0.01 c0,0-0.311-1.251-0.458-2.536c-0.077-0.641-0.124-1.287-0.138-1.772c-0.007-0.482-0.012-0.803-0.012-0.803 c-0.006-0.378,0.296-0.512,0.674-0.517s0.888-0.148,0.894,0.852h0.199V303.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1685.083,313.066c0,0,0.128,0.28,0.319,0.699c0.194,0.416,0.466,0.966,0.754,1.508 c0.572,1.087,1.218,2.136,1.218,2.136c0.198,0.32,0.098,0.74-0.223,0.938c-0.32,0.197-0.74,0.098-0.938-0.223l-0.003-0.005 c0,0-0.667-1.081-1.26-2.207c-0.298-0.562-0.581-1.133-0.784-1.566c-0.198-0.433-0.33-0.722-0.33-0.722 c-0.156-0.343-0.005-0.748,0.337-0.905c0.343-0.157,0.748-0.006,0.904,0.337l0,0L1685.083,313.066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1690.149,321.484c0,0,0.742,0.994,1.523,1.956c0.776,0.965,1.59,1.898,1.59,1.898 c0.246,0.283,0.217,0.712-0.066,0.958c-0.283,0.246-0.713,0.215-0.96-0.068c0,0-0.83-0.951-1.622-1.935 c-0.796-0.98-1.55-1.989-1.55-1.989l-0.005-0.007c-0.225-0.301-0.163-0.727,0.138-0.952 C1689.497,321.121,1689.924,321.183,1690.149,321.484L1690.149,321.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1696.636,328.96c0,0,0.874,0.878,1.782,1.722c0.904,0.847,1.839,1.659,1.839,1.659 c0.282,0.245,0.313,0.673,0.067,0.955c-0.245,0.282-0.674,0.311-0.957,0.066c0,0-0.953-0.827-1.874-1.689 c-0.924-0.858-1.815-1.752-1.815-1.752l-0.004-0.004c-0.264-0.265-0.264-0.695,0.002-0.959 C1695.942,328.694,1696.371,328.695,1696.636,328.96L1696.636,328.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1704.097,335.47c0,0,0.985,0.753,1.996,1.471c1.008,0.721,2.041,1.407,2.041,1.407 c0.31,0.206,0.395,0.625,0.189,0.935c-0.206,0.31-0.627,0.394-0.937,0.188c0,0-1.05-0.697-2.076-1.43 c-1.027-0.728-2.03-1.494-2.03-1.494c-0.298-0.224-0.358-0.648-0.134-0.946c0.224-0.298,0.648-0.358,0.947-0.134L1704.097,335.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1712.34,340.973c0,0,1.07,0.627,2.161,1.221c1.088,0.597,2.193,1.16,2.193,1.16 c0.331,0.169,0.462,0.574,0.294,0.905c-0.169,0.331-0.575,0.462-0.906,0.293c0,0-1.122-0.571-2.226-1.177 c-1.105-0.601-2.192-1.238-2.192-1.238c-0.322-0.186-0.433-0.598-0.247-0.92c0.186-0.322,0.598-0.433,0.92-0.247L1712.34,340.973z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1721.157,345.494l4.612,1.933c0.341,0.143,0.502,0.536,0.359,0.877 c-0.143,0.341-0.536,0.502-0.877,0.359l-4.612-1.931c-0.342-0.143-0.503-0.536-0.36-0.879 C1720.421,345.512,1720.814,345.351,1721.157,345.494L1721.157,345.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1730.408,349.123l4.765,1.514c0.352,0.112,0.546,0.487,0.434,0.839 c-0.111,0.352-0.487,0.546-0.839,0.434l-4.766-1.512c-0.352-0.112-0.547-0.488-0.435-0.84 C1729.679,349.206,1730.056,349.011,1730.408,349.123L1730.408,349.123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1739.946,351.947l4.867,1.146c0.358,0.084,0.58,0.443,0.495,0.801 c-0.085,0.358-0.443,0.58-0.801,0.495l-4.867-1.144c-0.359-0.084-0.581-0.443-0.497-0.802 C1739.228,352.085,1739.587,351.863,1739.946,351.947L1739.946,351.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1749.673,354.065l4.932,0.826c0.361,0.061,0.605,0.403,0.545,0.764 c-0.061,0.361-0.402,0.605-0.764,0.545l-4.932-0.823c-0.362-0.06-0.607-0.403-0.546-0.765S1749.311,354.005,1749.673,354.065 L1749.673,354.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1759.521,355.567l4.97,0.547c0.363,0.04,0.625,0.367,0.585,0.73 c-0.04,0.363-0.366,0.625-0.729,0.585l-4.97-0.544c-0.364-0.04-0.626-0.367-0.586-0.73S1759.157,355.527,1759.521,355.567 L1759.521,355.567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1769.44,356.532l4.992,0.294c0.363,0.021,0.641,0.333,0.619,0.697s-0.333,0.641-0.696,0.619 l-4.991-0.292c-0.364-0.021-0.642-0.334-0.62-0.697C1768.764,356.788,1769.076,356.51,1769.44,356.532L1769.44,356.532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1779.395,356.986l5,0.03c0.363,0.002,0.655,0.298,0.653,0.661c-0.002,0.363-0.298,0.655-0.66,0.653 l-5-0.028c-0.363-0.002-0.656-0.298-0.654-0.661C1778.734,357.276,1779.031,356.984,1779.395,356.986L1779.395,356.986z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1789.359,356.919l4.994-0.224c0.361-0.016,0.667,0.263,0.683,0.624 c0.016,0.361-0.263,0.667-0.624,0.683l-4.994,0.226c-0.362,0.016-0.668-0.264-0.685-0.625 C1788.718,357.242,1788.997,356.935,1789.359,356.919L1789.359,356.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1799.31,356.35l4.978-0.467c0.359-0.034,0.677,0.23,0.71,0.588c0.034,0.359-0.229,0.677-0.588,0.71 l-4.978,0.469c-0.359,0.034-0.678-0.23-0.712-0.589C1798.687,356.702,1798.95,356.384,1799.31,356.35L1799.31,356.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1809.224,355.304l4.952-0.694c0.356-0.05,0.684,0.198,0.734,0.553 c0.05,0.355-0.198,0.684-0.553,0.734l-4.951,0.697c-0.356,0.05-0.685-0.198-0.735-0.554 C1808.62,355.683,1808.868,355.354,1809.224,355.304L1809.224,355.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1819.083,353.812l4.917-0.905c0.352-0.065,0.69,0.168,0.754,0.52 c0.065,0.352-0.168,0.689-0.52,0.754l-4.917,0.907c-0.352,0.065-0.691-0.168-0.756-0.52 C1818.498,354.216,1818.731,353.877,1819.083,353.812L1819.083,353.812z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1828.874,351.909l4.878-1.098c0.348-0.078,0.693,0.14,0.771,0.488 c0.078,0.348-0.14,0.693-0.488,0.771l-4.878,1.1c-0.348,0.078-0.694-0.14-0.773-0.488 C1828.307,352.334,1828.526,351.988,1828.874,351.909L1828.874,351.909z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1838.587,349.63l4.836-1.271c0.344-0.09,0.695,0.115,0.785,0.458 c0.09,0.344-0.115,0.695-0.458,0.785l-4.835,1.273c-0.344,0.091-0.697-0.115-0.787-0.459 C1838.037,350.073,1838.243,349.721,1838.587,349.63L1838.587,349.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1848.217,347.014l4.792-1.426c0.339-0.101,0.696,0.092,0.797,0.431 c0.101,0.339-0.092,0.696-0.431,0.797l-4.792,1.428c-0.34,0.101-0.697-0.092-0.799-0.432 C1847.683,347.473,1847.877,347.115,1848.217,347.014L1848.217,347.014z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1857.761,344.097l4.749-1.563c0.335-0.11,0.696,0.072,0.806,0.407 c0.11,0.335-0.072,0.696-0.407,0.806l-4.748,1.565c-0.335,0.111-0.697-0.072-0.807-0.407 C1857.243,344.569,1857.426,344.207,1857.761,344.097L1857.761,344.097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1867.223,340.915l4.708-1.681c0.331-0.118,0.695,0.054,0.813,0.385 c0.118,0.331-0.054,0.695-0.385,0.813l-4.708,1.684c-0.331,0.118-0.696-0.054-0.815-0.386 C1866.719,341.399,1866.891,341.034,1867.223,340.915L1867.223,340.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1876.608,337.504l4.671-1.783c0.327-0.125,0.693,0.039,0.818,0.366s-0.039,0.694-0.366,0.818 l-4.67,1.785c-0.328,0.125-0.695-0.039-0.82-0.366C1876.116,337.997,1876.28,337.63,1876.608,337.504L1876.608,337.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1885.922,333.897l4.637-1.869c0.324-0.13,0.692,0.026,0.822,0.35 c0.13,0.324-0.026,0.692-0.35,0.822l-4.637,1.871c-0.324,0.131-0.693-0.026-0.824-0.35 C1885.441,334.397,1885.598,334.028,1885.922,333.897L1885.922,333.897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1895.173,330.126l4.609-1.939c0.321-0.135,0.69,0.016,0.825,0.336 c0.135,0.32-0.016,0.689-0.336,0.824l-4.608,1.941c-0.321,0.135-0.691-0.015-0.826-0.336 C1894.702,330.631,1894.852,330.261,1895.173,330.126L1895.173,330.126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1904.371,326.22l4.585-1.995c0.318-0.138,0.687,0.007,0.825,0.325 c0.139,0.318-0.007,0.687-0.324,0.825l-4.584,1.997c-0.318,0.139-0.689-0.007-0.827-0.325 C1903.907,326.73,1904.052,326.359,1904.371,326.22L1904.371,326.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1913.525,322.21l4.566-2.037c0.315-0.141,0.685,0.001,0.825,0.316 c0.141,0.315-0.001,0.685-0.316,0.825l-4.565,2.039c-0.316,0.141-0.686-0.001-0.827-0.316 C1913.068,322.722,1913.209,322.351,1913.525,322.21L1913.525,322.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1922.647,318.123l4.554-2.065c0.313-0.142,0.682-0.003,0.824,0.31s0.003,0.682-0.31,0.824 l-4.553,2.067c-0.314,0.142-0.684,0.004-0.826-0.31C1922.194,318.635,1922.333,318.265,1922.647,318.123L1922.647,318.123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1931.749,313.985l4.547-2.079c0.312-0.143,0.68-0.005,0.822,0.306 c0.142,0.312,0.005,0.68-0.306,0.822l-4.546,2.082c-0.312,0.143-0.681,0.006-0.824-0.306 C1931.3,314.497,1931.437,314.128,1931.749,313.985L1931.749,313.985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1940.842,309.824l4.546-2.081c0.31-0.142,0.677-0.006,0.819,0.305 c0.142,0.31,0.006,0.677-0.305,0.819l-4.545,2.083c-0.311,0.143-0.678,0.006-0.821-0.305 C1940.394,310.334,1940.531,309.967,1940.842,309.824L1940.842,309.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1949.938,305.665l4.552-2.07c0.31-0.141,0.675-0.004,0.816,0.306 c0.141,0.31,0.004,0.675-0.306,0.815l-4.551,2.072c-0.31,0.141-0.676,0.004-0.817-0.306 C1949.49,306.172,1949.627,305.807,1949.938,305.665L1949.938,305.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1959.049,301.535l4.563-2.045c0.309-0.139,0.672,0,0.811,0.309 c0.139,0.309,0.001,0.672-0.309,0.811l-4.562,2.047c-0.31,0.139-0.674,0.001-0.813-0.309 C1958.6,302.038,1958.739,301.674,1959.049,301.535L1959.049,301.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1968.186,297.46l4.579-2.007c0.309-0.135,0.67,0.005,0.805,0.315 c0.136,0.309-0.005,0.67-0.314,0.805l-4.579,2.009c-0.31,0.136-0.671-0.005-0.807-0.315 C1967.735,297.957,1967.876,297.596,1968.186,297.46L1968.186,297.46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1977.362,293.466l4.602-1.956c0.31-0.132,0.667,0.013,0.799,0.322s-0.013,0.667-0.322,0.799 l-4.601,1.958c-0.31,0.132-0.669-0.013-0.801-0.323C1976.907,293.957,1977.051,293.598,1977.362,293.466L1977.362,293.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1986.587,289.583l4.629-1.889c0.31-0.127,0.665,0.022,0.791,0.333 c0.127,0.31-0.022,0.664-0.333,0.791l-4.628,1.892c-0.311,0.127-0.666-0.022-0.793-0.333 C1986.126,290.065,1986.276,289.71,1986.587,289.583L1986.587,289.583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1995.871,285.839l4.661-1.808c0.311-0.121,0.662,0.034,0.783,0.345 c0.121,0.311-0.034,0.661-0.345,0.782l-4.661,1.81c-0.312,0.121-0.663-0.034-0.784-0.345 C1995.404,286.311,1995.558,285.96,1995.871,285.839L1995.871,285.839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2005.224,282.265l4.698-1.711c0.313-0.114,0.658,0.047,0.772,0.36s-0.047,0.658-0.36,0.772 l-4.697,1.713c-0.313,0.114-0.66-0.047-0.774-0.36C2004.749,282.726,2004.91,282.379,2005.224,282.265L2005.224,282.265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2014.653,278.892l4.738-1.598c0.314-0.106,0.655,0.063,0.76,0.377 c0.106,0.314-0.063,0.654-0.377,0.76l-4.737,1.6c-0.315,0.106-0.656-0.063-0.762-0.377 C2014.169,279.34,2014.338,278.999,2014.653,278.892L2014.653,278.892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2024.165,275.755l4.78-1.467c0.316-0.097,0.65,0.081,0.747,0.396 c0.097,0.316-0.08,0.65-0.396,0.747l-4.779,1.469c-0.316,0.097-0.651-0.08-0.748-0.396 C2023.671,276.187,2023.849,275.852,2024.165,275.755L2024.165,275.755z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2033.765,272.888l4.823-1.318c0.317-0.087,0.645,0.1,0.732,0.417 c0.087,0.317-0.1,0.645-0.417,0.732l-4.823,1.32c-0.318,0.087-0.646-0.1-0.733-0.418 C2033.259,273.303,2033.447,272.975,2033.765,272.888L2033.765,272.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2043.452,270.328l4.866-1.151c0.319-0.076,0.638,0.122,0.714,0.441 c0.075,0.319-0.122,0.639-0.44,0.714l-4.865,1.153c-0.319,0.076-0.64-0.122-0.716-0.441 C2042.935,270.724,2043.132,270.404,2043.452,270.328L2043.452,270.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2053.226,268l4.911-0.911c0.32-0.063,0.63,0.173,0.693,0.493c0.063,0.32-0.145,0.644-0.465,0.707 l-0.009,0.009l-4.9,0.971c-0.321,0.064-0.633-0.198-0.697-0.518c-0.064-0.321,0.143-0.751,0.464-0.751H2053.226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2063.071,266l4.934-0.682c0.316-0.052,0.614,0.227,0.666,0.543 c0.052,0.316-0.161,0.646-0.477,0.698l-4.932,0.838c-0.319,0.053-0.62-0.284-0.673-0.602c-0.053-0.319,0.162-0.795,0.481-0.795 H2063.071z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2072.969,265l4.958-0.792c0.312-0.041,0.598,0.107,0.638,0.419c0.041,0.312-0.178,0.561-0.49,0.602 l-4.957,0.64c-0.315,0.042-0.604-0.044-0.645-0.359c-0.042-0.315,0.179-0.51,0.494-0.51H2072.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2082.918,264l4.979-0.704c0.307-0.028,0.58,0.074,0.608,0.382c0.028,0.307-0.197,0.517-0.504,0.546 l-4.978,0.437c-0.31,0.029-0.585,0.033-0.615-0.277c-0.029-0.31,0.199-0.383,0.509-0.383H2082.918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2092.909,263l4.994-0.39c0.302-0.014,0.559,0.143,0.574,0.446c0.014,0.303-0.218,0.521-0.521,0.536 l-4.994,0.229c-0.305,0.015-0.565-0.077-0.581-0.383c-0.015-0.305,0.22-0.438,0.526-0.438H2092.909z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2102.929,262l5,0.184c0.297,0.001,0.537,0.327,0.537,0.625c-0.001,0.297-0.241,0.58-0.538,0.579 l-5,0.019c-0.3,0-0.543-0.403-0.543-0.703c0-0.3,0.244-0.703,0.544-0.703H2102.929z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2112.958,263l4.991,0.049c0.291,0.017,0.513,0.143,0.495,0.434 c-0.017,0.291-0.266,0.451-0.557,0.434l-4.992-0.316c-0.294-0.017-0.518-0.037-0.502-0.331c0.017-0.294,0.269-1.27,0.563-0.27 H2112.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2122.962,263l4.962,0.738c0.283,0.035,0.485,0.356,0.45,0.64c-0.035,0.284-0.292,0.517-0.575,0.482 l-4.964-0.585c-0.286-0.035-0.49-0.414-0.456-0.7c0.035-0.286,0.295-0.575,0.581-0.575H2122.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2132.898,265l4.907,0.784c0.275,0.054,0.454,0.233,0.4,0.507c-0.054,0.275-0.319,0.411-0.594,0.357 l-4.909-0.969c-0.278-0.054-0.459-0.159-0.406-0.436c0.053-0.278,0.322-0.242,0.6-0.242H2132.898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2142.704,266.758l1.305,0.34c0.267,0.07,0.427,0.343,0.358,0.61 c-0.07,0.267-0.342,0.428-0.609,0.358l-1.306-0.337c-0.268-0.069-0.429-0.343-0.36-0.611 C2142.161,266.85,2142.435,266.688,2142.704,266.758L2142.704,266.758z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1506.847,375.459 1506.972,408.388 1484.616,394.316  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1358.697,357.118l89.224,77.667c1.708,1.487,3.948,2.215,6.204,2.016 c2.256-0.199,4.334-1.307,5.756-3.07l74.604-92.521c0.854-1.059,0.98-2.531,0.319-3.72c-0.661-1.189-1.978-1.859-3.329-1.692 L1358.697,357.118z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1506.837,375.462 1358.697,357.118 1494.843,390.431 1495.266,399.561  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1487.665,399.252 1506.972,408.388 1494.843,390.431  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSupport);
export default __webpack_public_path__ + "static/media/image_support.d065dc82dd0544963bb7958fcfad263f.svg";
export { ForwardRef as ReactComponent };